import React,{ Fragment, PureComponent, } from 'react'
import {Modal, Popconfirm, Result, Spin} from 'antd';
import PropTypes from 'prop-types';

import Lang from "@/components/Lang/Lang";

/**
 * 弹窗组件
 * @author FJJ
 * @version 1.0
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * 多语言
 **/
class EssaModal extends PureComponent {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onCancel: PropTypes.func.isRequired,
        width: PropTypes.number,
        okText:PropTypes.string,
        cancelText:PropTypes.string,
    }
    static defaultProps = {
        visible: false,
        options:[],
        initialValues:{},
        width: 600,
        footer: '',
        formItemLayout:{},
        okText:'',
        cancelText:'',
        maskClosable:true
    };
    componentDidMount() {
      if( this.props.onRef)  this.props.onRef(this);
    };
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { open, onCancel, width,title,onOk,okText,cancelText,footer,maskClosable,closable,destroyOnHidden=false,wrapClassName=""} = this.props;
        let config = {
            title:title,
            open:open,
            width:width,
            destroyOnHidden:destroyOnHidden,
            wrapClassName:wrapClassName
        }
        if(footer||footer==null){
            config["footer"] = footer
        }
        if(closable||closable==false){
            config["closable"] = closable
        }
        return (<Fragment>
            <Modal {...config}
                   width={width}
                   maskClosable={maskClosable}
                okText={okText||Lang({id:'QueDing',default:'确定'})}
                cancelText={cancelText||Lang({id:'QuXiao',default:'取消'})}
                onCancel={onCancel}
                onOk={onOk}
            >
                <div style={{maxHeight:"70vh",overflowY:"auto",paddingRight:"8px"}}>
                {this.props.children}
                </div>
            </Modal>
        </Fragment>);
    }
}
export default EssaModal;
